<p>create-user-callback works!</p>
